import { graphQueryBang } from "shared/lib/graphql"
import { SubscriptionUpdateMutation } from "./queries"

export const upgradeProPlus = async ({ productId }) => {
  const response = await graphQueryBang(SubscriptionUpdateMutation, {
    product_id: productId,
  })
  return response.userSubscriptionUpdate
}
